import { render, staticRenderFns } from "./dispensation4.vue?vue&type=template&id=460ac78c&scoped=true"
import script from "./dispensation4.vue?vue&type=script&lang=js"
export * from "./dispensation4.vue?vue&type=script&lang=js"
import style0 from "./dispensation4.vue?vue&type=style&index=0&id=460ac78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ac78c",
  null
  
)

export default component.exports